import * as React from "react";

import { cn } from "./utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "border-input flex h-10 w-full rounded-md border px-3 py-2 text-base bg-input-background " +
          "placeholder:text-muted-foreground transition-all outline-none disabled:pointer-events-none disabled:opacity-50",
        "focus-visible:border-[var(--ring)] focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:ring-offset-1",
        className
      )}
      {...props}
    />
  );
}

export { Input };
